// notificationsData.js — jeu de démonstration (8 notifications) + forme du
// view-model. Sert de repli quand la prop `notifications` n'est pas fournie.
// Montants en F CFA (groupage fr-FR). Tout en français.
import { fmt } from "./notificationsShared";

// Forme d'UNE notification (view-model attendu par <NotificationsMobile>) :
// {
//   id:        string|number               // identifiant unique
//   type:      'commande'|'paiement'|'stock'|'tache'|'systeme'
//   read:      boolean
//   bucket:    'today'|'yesterday'|'earlier'   // pour le regroupement par date
//   time:      string                       // libellé relatif ("il y a 51 min")
//   title:     string
//   org:       string                       // entreprise / société
//   msg:       string                       // phrase de contexte (corps du modal)
//   meta:      [{ ic, t, strong? }]         // 1–3 infos clés sur la carte
//   amount?:   string                       // montant mis en avant (déjà formaté)
//   detail:    [{ ic, k, v, amount? }]      // lignes du modal de détail
//   cta:       { ic, label, to? }           // action principale + destination
// }
export function getDemoNotifications() {
  return [
    {
      id: "n1", type: "commande", read: false, bucket: "today", time: "il y a 51 min",
      title: "Nouvelle commande e-commerce", org: "ELSA GESTION INC",
      msg: "Une nouvelle commande vient d'être passée sur votre boutique en ligne et attend votre traitement.",
      meta: [
        { ic: "package", t: "2 produits · 3 unités" },
        { ic: "user", t: "Anthony Pierre Sib" },
        { ic: "store", t: "MAMAN JOS" },
      ],
      amount: fmt(1500),
      detail: [
        { ic: "hash", k: "Commande", v: "ORD_178181084693" },
        { ic: "package", k: "Articles", v: "2 produits · 3 unités" },
        { ic: "wallet", k: "Montant", v: fmt(1500), amount: true },
        { ic: "user", k: "Client", v: "Anthony Pierre Sib" },
        { ic: "store", k: "Point de vente", v: "MAMAN JOS" },
        { ic: "clock", k: "Reçue", v: "Aujourd'hui · 09:14" },
      ],
      cta: { ic: "arrow-up-right", label: "Voir la commande", to: "/ventes/commandes/ORD_178181084693" },
    },
    {
      id: "n2", type: "paiement", read: false, bucket: "today", time: "il y a 2 h",
      title: "Paiement reçu", org: "ELSA GESTION INC",
      msg: "Un règlement a été encaissé pour la facture FAC-2026-0418.",
      meta: [
        { ic: "smartphone", t: "Mobile Money" },
        { ic: "user", t: "Société KABORÉ" },
      ],
      amount: fmt(45000),
      detail: [
        { ic: "hash", k: "Facture", v: "FAC-2026-0418" },
        { ic: "wallet", k: "Montant", v: fmt(45000), amount: true },
        { ic: "smartphone", k: "Mode", v: "Mobile Money" },
        { ic: "user", k: "Client", v: "Société KABORÉ" },
        { ic: "clock", k: "Encaissé", v: "Aujourd'hui · 07:42" },
      ],
      cta: { ic: "arrow-up-right", label: "Voir la facture", to: "/ventes/factures/FAC-2026-0418" },
    },
    {
      id: "n3", type: "stock", read: false, bucket: "today", time: "il y a 3 h",
      title: "Alerte de stock bas : Hot chocolate", org: "ELSA GESTION INC",
      msg: "Le stock de « Hot chocolate » est passé sous le seuil d'alerte. Pensez à réapprovisionner.",
      meta: [
        { ic: "layers", t: "Reste 4 unités", strong: true },
        { ic: "bell", t: "Seuil : 10" },
      ],
      detail: [
        { ic: "box", k: "Produit", v: "Hot chocolate" },
        { ic: "layers", k: "Stock restant", v: "4 unités" },
        { ic: "bell", k: "Seuil d'alerte", v: "10 unités" },
        { ic: "store", k: "Établissement", v: "Magasin Central" },
      ],
      cta: { ic: "plus", label: "Réapprovisionner", to: "/inventaire/reappro" },
    },
    {
      id: "n4", type: "tache", read: false, bucket: "yesterday", time: "hier · 16:30",
      title: "Validation requise : Bon de commande", org: "ELSA GESTION INC",
      msg: "Le bon de commande BC-0091 est en attente de votre approbation.",
      meta: [{ ic: "user", t: "Awa Traoré" }],
      amount: fmt(220000),
      detail: [
        { ic: "hash", k: "Bon de commande", v: "BC-0091" },
        { ic: "wallet", k: "Montant", v: fmt(220000), amount: true },
        { ic: "user", k: "Demandeur", v: "Awa Traoré" },
        { ic: "truck", k: "Fournisseur", v: "Sahel Distribution" },
        { ic: "clock", k: "Soumis", v: "Hier · 16:30" },
      ],
      cta: { ic: "arrow-up-right", label: "Examiner", to: "/achats/bons-commande/BC-0091" },
    },
    {
      id: "n5", type: "stock", read: true, bucket: "yesterday", time: "hier · 11:05",
      title: "Alerte de stock bas : Sauce pistache", org: "ELSA GESTION INC",
      msg: "Le stock de « Sauce pistache » est passé sous le seuil d'alerte.",
      meta: [
        { ic: "layers", t: "Reste 2 unités", strong: true },
        { ic: "bell", t: "Seuil : 8" },
      ],
      detail: [
        { ic: "box", k: "Produit", v: "Sauce pistache" },
        { ic: "layers", k: "Stock restant", v: "2 unités" },
        { ic: "bell", k: "Seuil d'alerte", v: "8 unités" },
        { ic: "store", k: "Établissement", v: "Magasin Central" },
      ],
      cta: { ic: "plus", label: "Réapprovisionner", to: "/inventaire/reappro" },
    },
    {
      id: "n6", type: "commande", read: true, bucket: "yesterday", time: "hier · 09:20",
      title: "Commande livrée", org: "ELSA GESTION INC",
      msg: "La commande ORD_178180044121 a été marquée comme livrée.",
      meta: [
        { ic: "user", t: "Fatou Diallo" },
        { ic: "map-pin", t: "Ouagadougou" },
      ],
      amount: fmt(12750),
      detail: [
        { ic: "hash", k: "Commande", v: "ORD_178180044121" },
        { ic: "wallet", k: "Montant", v: fmt(12750), amount: true },
        { ic: "user", k: "Client", v: "Fatou Diallo" },
        { ic: "map-pin", k: "Livraison", v: "Ouagadougou" },
      ],
      cta: { ic: "arrow-up-right", label: "Voir la commande", to: "/ventes/commandes/ORD_178180044121" },
    },
    {
      id: "n7", type: "paiement", read: true, bucket: "earlier", time: "il y a 4 j",
      title: "Clôture de caisse", org: "ELSA GESTION INC",
      msg: "La caisse du point de vente MAMAN JOS a été clôturée.",
      meta: [{ ic: "store", t: "MAMAN JOS" }],
      amount: fmt(312400),
      detail: [
        { ic: "wallet", k: "Total encaissé", v: fmt(312400), amount: true },
        { ic: "store", k: "Point de vente", v: "MAMAN JOS" },
        { ic: "user", k: "Caissier", v: "Issa Ouédraogo" },
        { ic: "clock", k: "Clôturée", v: "Il y a 4 jours · 19:58" },
      ],
      cta: { ic: "arrow-up-right", label: "Voir le rapport", to: "/caisse/cloture" },
    },
    {
      id: "n8", type: "systeme", read: true, bucket: "earlier", time: "il y a 5 j",
      title: "Mise à jour installée", org: "ELSA TECHNOLOGIES",
      msg: "La version 2.4 d'Elsa Gestion a été installée. Nouvelle gestion des retours et performances améliorées.",
      meta: [{ ic: "git-branch", t: "Version 2.4" }],
      detail: [
        { ic: "git-branch", k: "Version", v: "2.4.0" },
        { ic: "sparkles", k: "Nouveautés", v: "Retours · Performances" },
        { ic: "clock", k: "Installée", v: "Il y a 5 jours" },
      ],
      cta: { ic: "arrow-up-right", label: "Voir les nouveautés", to: "/parametres/nouveautes" },
    },
  ];
}
